import { createStore, combineReducers, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { createReduxHistoryContext } from "redux-first-history";
import { createBrowserHistory } from "history";
import thunk from "redux-thunk";
import auth from "./modules/auth";
import UI from "./modules/UI";
import profile from "./modules/profile";
import invitation from "./modules/invitation";
import lists from "./modules/lists";
import opportunity from "./modules/opportunity";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";

const { createReduxHistory, routerMiddleware, routerReducer } =
  createReduxHistoryContext({
    history: createBrowserHistory(),
  });

const appReducer = combineReducers({
  router: routerReducer,
  auth,
  UI,
  profile,
  invitation,
  lists,
  opportunity,
});

const rootReducers = (state, action) => {
  if (action.type === "USER_LOGOUT") {
    localStorage.clear();
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export const store = createStore(
  rootReducers,
  composeWithDevTools(applyMiddleware(routerMiddleware, thunk))
);

export const history = createReduxHistory(store);

type AppState = ReturnType<typeof rootReducers>;

type TypedDispatch<T> = ThunkDispatch<T, any, AnyAction>;

export const useAppDispatch = () => useDispatch<TypedDispatch<AppState>>();

export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;
